<template>
    <!--理财产品详情-->
    <el-dialog
      title="产品详情"
      :visible.sync="prdDetailVisible"
      width="1000px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      append-to-body>
      <div class="detailDiv">
        <el-row class="detailRow">
          <el-col :span="6" class="detailTitle">产品代码</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.prdCode | emptyCheckFilter}}</el-col>
          <el-col :span="6" class="detailTitle">产品名称</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.prdName | emptyCheckFilter}}</el-col>
        </el-row>
        <el-row class="detailRow">
          <el-col :span="6" class="detailTitle">产品状态</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.statusRes | emptyCheckFilter}}</el-col>
          <el-col :span="6" class="detailTitle">起购金额(元)</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.purchaseAmounts | moneyFilter}}</el-col>
        </el-row>
        <el-row class="detailRow">
          <el-col :span="6" class="detailTitle">投资期限(天)</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.investTerm | emptyCheckFilter}}</el-col>
          <el-col :span="6" class="detailTitle">预期年化收益率</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.expAnnualYield | emptyCheckFilter}}</el-col>
        </el-row>
        <el-row class="detailRow">
          <el-col :span="6" class="detailTitle">业绩比较基准</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.performanceCriterion | emptyCheckFilter}}</el-col>
          <el-col :span="6" class="detailTitle">七日年化收益率</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.weekAnnualYield | emptyCheckFilter}}%</el-col>
        </el-row>
        <el-row class="detailRow">
          <el-col :span="6" class="detailTitle">收益类型</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.yieldTypeRes | emptyCheckFilter}}</el-col>
          <el-col :span="6" class="detailTitle">风险等级</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.riskLevelRes | emptyCheckFilter}}</el-col>
        </el-row>
        <el-row class="detailRow">
          <el-col :span="6" class="detailTitle">运作模式</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.operationModeRes | emptyCheckFilter}}</el-col>
          <el-col :span="6" class="detailTitle">投资资产类型</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.investAssetClassRes | emptyCheckFilter}}</el-col>
        </el-row>
        <el-row class="detailRow">
          <el-col :span="6" class="detailTitle">最新净值</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.newsetNetValue | emptyCheckFilter}}</el-col>
          <el-col :span="6" class="detailTitle">最新净值日期</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.newsetNetValueDate | formatToD}}</el-col>
        </el-row>
        <el-row class="detailRow">
          <el-col :span="6" class="detailTitle">初始净值</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.initialNetValue | emptyCheckFilter}}</el-col>
          <el-col :span="6" class="detailTitle">累计净值</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.accumultedNetValue | emptyCheckFilter}}</el-col>
        </el-row>
        <el-row class="detailRow">
          <el-col :span="6" class="detailTitle">最近一次兑付收益率</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.latestCashYield | emptyCheckFilter}}%</el-col>
          <el-col :span="6" class="detailTitle">购买递增金额(元)</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.increaseAmounts | moneyFilter}}</el-col>
        </el-row>
        <el-row class="detailRow">
          <el-col :span="6" class="detailTitle">单笔最高限额(元)</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.singleMaxAmounts | moneyFilter}}</el-col>
          <el-col :span="6" class="detailTitle">发售总额(元)</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.saleAmt | moneyFilter}}</el-col>
        </el-row>
        <el-row class="detailRow">
          <el-col :span="6" class="detailTitle">可售余额(元)</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.remainAmounts | moneyFilter}}</el-col>
          <el-col :span="6" class="detailTitle">募集开始日</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.ipoStartDate | formatToD}}</el-col>
        </el-row>
        <el-row class="detailRow">
          <el-col :span="6" class="detailTitle">募集结束日</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.ipoEndDate |formatToD}}</el-col>
          <el-col :span="6" class="detailTitle">产品成立日</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.establishDate |formatToD}}</el-col>
        </el-row>
        <el-row class="detailRow">
          <el-col :span="6" class="detailTitle">产品到期日</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.expireDate |formatToD}}</el-col>
          <el-col :span="6" class="detailTitle">币种</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.currencyTypeRes | emptyCheckFilter}}</el-col>
        </el-row>
        <el-row class="detailRow">
          <el-col :span="6" class="detailTitle">是否可提前赎回</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.isAdvRedeemRes | emptyCheckFilter}}</el-col>
          <el-col :span="6" class="detailTitle">发行机构</el-col>
          <el-col :span="6" class="detailKey">{{financeDetail.issueOrgCode | emptyCheckFilter}}</el-col>
        </el-row>
      </div>
      <el-row style="text-align:right">
        <el-button @click="prdDetailVisible = false" type="primary">关闭</el-button>
      </el-row>
    </el-dialog>
</template>
<script>
export default {
  name: 'financeDetailDialog',
  data() {
    return {
      prdDetailVisible: false,
      financeDetail: {},
    };
  },
  filters: {
    // 保留两位小数，增加千分符
    moneyFilter(x) {
      // 将入参x转换成float类型的小数。假设入参为100000
      const f = parseFloat(x);
      // console.log(f)
      // 如果为空则返回默认值
      if (isNaN(f)) {
        return '0.00';
      }
      // 将入参四舍五入并保留两位小数
      const f2 = Math.round(x * 100) / 100;
      // 将四舍五入后的入参转为字符类型
      let s = f2.toString();
      // 筛选该入参中是否有小数点 有则返回小数点的位置，没有则返回-1
      let rs = s.indexOf('.');
      // 小于0，代表该入参没有小数点，所以该入参为整数
      if (rs < 0) {
        // 将入参的长度赋值给rs
        rs = s.length;
        // 在入参后连上小数点
        s += '.';
      }
      // 循环在入参后补 100000.00
      while (s.length <= rs + 2) {
        // 补0
        s += '0';
      }
      // 将入参根据小数点分割成两部分。分割后为100000和00。
      const parts = s.toString().split('.');
      // parts[0]为取左边整数位。         👇是正则表达式，如果整数位大于3，就在后边添加逗号(千分符)
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      // 将分割的入参，重新拼起来  100,000.00
      return parts.join('.');
    },
  },
  methods: {
    // 理财产品详情查询
    getFinanceDetail(prdId) {
      this.prdDetailVisible = true;
      if (prdId === '') {
        return;
      }
      const params = {
        data: {
          prdId,
          prdType: '1',
          token: JSON.parse(sessionStorage.getItem('userToken')),
          userId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
        },
      };
      this.$_post(this.$API.getFinanceDetail, params).then((res) => {
        this.financeDetail = res.data.productInfo;
      }).catch((err) => {
        console.log(err);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  .detailRow {
    border: 1px solid #EBEEF5;
    border-bottom: 0px;
  }
  .detailRow:last-child {
    border-bottom: 1px solid #EBEEF5;
  }
  .detailDiv {
    position: relative;
    top: -20px;
  }
  .detailTitle {
    background-color: #F5F7FA;
    padding: 15px 15px 15px 0;
    text-align: right;
  }
  .detailKey {
    padding: 15px 0px 15px 15px;
  }
</style>
